module.exports = __webpack_public_path__ + "img/help-octagon.2abe003d.svg";